@if (!dataService.error() && !optionListService.dataLoading() && !isFxratesLoading() && !userDataService.dataLoading() && depositAvailable) {
    @if (depositService.showODpopUp()) {
        <app-od-popup />
    } @else {
        <app-deposit />
    }
}
